<template>
  <div id="app" class="w-screen h-ipad bg-black text-white antialiased flex flex-col items-center text-base">
    <NavBar />

    <router-view></router-view>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
export default {
  name: 'app',
  components: {
    NavBar
  }
}
</script>

<style>
/* Base Configuration Styles are shared across multiple pages */

body {
  background-color: #000000;
}

.low-rise-background {
  width: 359px;
  position: absolute;
  top: 126px;
  left: 50%;
  transform: translate(-50%);
}

.low-rise-config .zoneB-row {
  margin-top: 20px;
}

.low-rise-config .zoneC-row {
  margin-top: 15px;
}

.low-rise-config .zoneA-image img {
  width: 359px;
}

.low-rise-config .zoneB-image img {
  width: 359px;
}

.low-rise-config .zoneC-image img {
  max-height: 120px;
  margin-right: 18px;
}

.mid-rise-background {
  width: 359px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translate(-50%);
}

.mid-rise-config .zoneB-row {
  margin-top: 5px;
}

.mid-rise-config .zoneA-image img {
  width: 359px;
}

.mid-rise-config .zoneB-image img {
  width: 248px;
  margin-right: 6px;
}


.high-rise-background {
  width: 359px;
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translate(-50%);
}

.high-rise-config .zoneA-image img {
  width: 359px;
}
</style>